import React from 'react';
import { motion } from 'framer-motion';

const PartnersSection = () => {
  // Partner logos matching ModArch theme style
  const partners = [
    { id: 1, name: 'Partner A', logo: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-pn-a.svg' },
    { id: 2, name: 'Partner B', logo: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-pn-b.svg' },
    { id: 3, name: 'Partner C', logo: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-pn-c.svg' },
    { id: 4, name: 'Partner D', logo: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-pn-d.svg' },
    { id: 5, name: 'Partner E', logo: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-pn-e.svg' },
    { id: 6, name: 'Partner F', logo: 'https://modarch.svb.la-studioweb.com/wp-content/uploads/2025/06/modarch-pn-f.svg' }
  ];

  return (
    <section className="partners-arch04">
      <div className="partners-arch04-container">
        <motion.h2 
          className="partners-arch04-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Trusted By<span>Worldwide Company</span>
        </motion.h2>

        <div className="partners-arch04-marquee">
          <div className="partners-arch04-track">
            {[...partners, ...partners].map((partner, index) => (
              <div key={index} className="partners-arch04-logo">
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
